import React from 'react';
import { Typography, Skeleton, Card } from 'antd';
import { useTranslation } from 'react-i18next';
import TagList from './TagList';
import styles from '../Profile.module.css';

const { Title } = Typography;

interface InterestsSectionProps {
  interests: string[];
  isLoading: boolean;
}

const InterestsSection: React.FC<InterestsSectionProps> = ({ interests, isLoading }) => {
  const { t } = useTranslation();

  // Don't render if no interests available
  if (!isLoading && (!interests || interests.length === 0)) {
    return null;
  }

  return (
    <Card className={styles.sectionCard} bordered={false}>
      <Title level={4} className={styles.sectionTitle}>
        {t('#Profile.interests')}
      </Title>

      <Skeleton loading={isLoading} paragraph={{ rows: 2 }} active>
        <TagList items={interests} />
      </Skeleton>
    </Card>
  );
};

export default InterestsSection;